module.exports = __webpack_public_path__ + "static/img/laboratory.3536adff.png";